// extracted by mini-css-extract-plugin
module.exports = {"th-news-banner":"styles_th-news-banner__o5NFR","th-banner-title":"styles_th-banner-title__AHdzj"};